import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Facebook, Instagram, Mail } from "lucide-react";

export default function Footer() {
  const year = new Date().getFullYear();
  const location = useLocation();

  const handleSamePageLink = (e, to) => {
    if (!to) return;
    if (location?.pathname === to) {
      e.preventDefault();
      try { window.scrollTo({ top: 0, left: 0, behavior: 'smooth' }); }
      catch { window.scrollTo(0, 0); }
    }
  };
  return (
    <footer className="bg-white border-t border-gray-200 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          <div>
            <h3 className="bg-gradient-to-r from-purple-600 to-blue-600 bg-clip-text text-transparent mb-4">
              キャッシュレス決済マップ
            </h3>
            <p className="text-muted-foreground text-sm">
              決済方法で選ばれる時代へ。<br />
              月300円・登録1分で、キャッシュレス対応を地図で届けます。
            </p>
          </div>

          <div>
            <h4 className="mb-4">サービス</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/lp" onClick={(e)=>handleSamePageLink(e,'/lp')} className="text-muted-foreground hover:text-foreground transition-colors">
                  掲載のご案内
                </Link>
              </li>
              <li>
                <Link to="/" onClick={(e)=>handleSamePageLink(e,'/')} className="text-muted-foreground hover:text-foreground transition-colors">
                  店舗を探す
                </Link>
              </li>
              <li>
                <Link to="/register" onClick={(e)=>handleSamePageLink(e,'/register')} className="text-muted-foreground hover:text-foreground transition-colors">
                  店舗登録
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="mb-4">サポート</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="mailto:customer-support-cashless@cashlessmap.com" className="text-muted-foreground hover:text-foreground transition-colors">
                  お問い合わせ
                </a>
              </li>
              <li>
                <Link to="/register" onClick={(e)=>handleSamePageLink(e,'/register')} className="text-muted-foreground hover:text-foreground transition-colors">
                  オーナー申請
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="mb-4">法務情報</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/legal/terms" onClick={(e)=>handleSamePageLink(e,'/legal/terms')} className="text-muted-foreground hover:text-foreground transition-colors">
                  利用規約
                </Link>
              </li>
              <li>
                <Link to="/legal/privacy" onClick={(e)=>handleSamePageLink(e,'/legal/privacy')} className="text-muted-foreground hover:text-foreground transition-colors">
                  プライバシーポリシー
                </Link>
              </li>
              <li>
                <Link to="/legal/tokushoho" onClick={(e)=>handleSamePageLink(e,'/legal/tokushoho')} className="text-muted-foreground hover:text-foreground transition-colors">
                  特定商取引法表示
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-border">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4 mb-4">
            <p className="text-sm text-muted-foreground">
              © {year} Cashless Map. All rights reserved.
            </p>
            <div className="flex items-center gap-4">
              <a
                href="https://www.facebook.com/profile.php?id=61582531834773"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-muted hover:bg-accent flex items-center justify-center transition-colors"
              >
                <Facebook size={18} className="text-muted-foreground" />
              </a>
              <a
                href="https://www.instagram.com/cashless_map/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-muted hover:bg-accent flex items-center justify-center transition-colors"
              >
                <Instagram size={18} className="text-muted-foreground" />
              </a>
              <a
                href="mailto:customer-support-cashless@cashlessmap.com"
                className="w-10 h-10 rounded-full bg-muted hover:bg-accent flex items-center justify-center transition-colors"
              >
                <Mail size={18} className="text-muted-foreground" />
              </a>
            </div>
          </div>
          <div className="text-xs text-muted-foreground text-center sm:text-left">
            <p className="mb-1">
              各決済ブランド名・ロゴは各社の商標または登録商標です。
            </p>
            <p>
              決済処理はStripeを使用しており、TLS暗号化により保護されています。当社はカード情報を保持しません。
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
